import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/life-sciences-elearning/page.tsx");
